import AxiosManager from "../_axiosManager";

export async function getBlogDetail(blogId: string) {
  const res = await AxiosManager.getInstance().get(
    `/admin/manage/blog/${blogId}`,
  );

  return res;
}

export async function postImg(body: any) {
  const res = await AxiosManager.getInstance().post("/upload/image", body);

  return res;
}

export async function postBlog(body: any) {
  const res = await AxiosManager.getInstance().post("/admin/manage/blog", body);

  return res;
}

export async function putBlog({ blogId, body }: any) {
  const res = await AxiosManager.getInstance().put(
    `/admin/manage/blog/${blogId}`,
    body,
  );

  return res;
}

export async function delBlog(blogId: string) {
  const res = await AxiosManager.getInstance().delete(
    `/admin/manage/blog/${blogId}`,
  );

  return res;
}
